import type { ReactNode } from 'react';
import { cn } from '@skupreme/shared/ui';

export type StopRowClickProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Keeps a click inside a row from navigating the row. Also covers portalled
 * surfaces, since React events bubble up the component tree.
 */
export function StopRowClick({ children, className }: StopRowClickProps) {
  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: the handler stops a click, it adds none
    // biome-ignore lint/a11y/useKeyWithClickEvents: the keyboard reaches the controls inside directly and never this span
    <span
      className={cn('sk:inline-flex sk:min-w-0', className)}
      onClick={event => event.stopPropagation()}
    >
      {children}
    </span>
  );
}
